import { render, staticRenderFns } from "./NotLoggedIn.vue?vue&type=template&id=56496b23"
import script from "./NotLoggedIn.vue?vue&type=script&lang=js"
export * from "./NotLoggedIn.vue?vue&type=script&lang=js"
import style0 from "./NotLoggedIn.vue?vue&type=style&index=0&id=56496b23&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports